import TextInput from '@/common/components/Inputs/TextInput/TextInput';

export default TextInput;
